import { useQuery } from 'react-query';

import type { IConversation } from 'src/api/landlord-messages-api';
import { apiClient, queryKeys } from 'src/services/api';

const PATH = 'api/landlord/conversations';

interface IGetConversationOptions {
    disabled?: boolean;
}

export const useConversation = (leadUuid: string, options?: IGetConversationOptions) => {
    return useQuery<IConversation>(
        // NOTE: must be consistent with use-conversations
        [queryKeys.conversations, 'lead', leadUuid],
        async () => {
            const res = await apiClient(`${PATH}/lead/${leadUuid}`).json<IConversation>();
            return res;
        }, {
            enabled: !options?.disabled && !!leadUuid,
            staleTime: Infinity,
        }
    );
};
